const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "CusName",
		label: "购买方名称",
		columnwidth: 200,
	},
	{
		prop: "Date",
		label: "出入库日期",
		columnwidth: 150,
	},
	{
		prop: "InvName",
		label: "产品名称",
		columnwidth: 160,
	},
	{
		prop: "InvAddCode",
		label: "产品型号",
		columnwidth: 160,
	},
	{
		prop: "Batch",
		label: "批号",
		columnwidth: 150,
	},
	{
		prop: "InvUniqueCode",
		label: "唯一码",
		columnwidth: 300,
	},
	{
		prop: "VoucherType",
		label: "出库类型",
		columnwidth: 120,
	},
	{
		prop: "Sum",
		label: "价格",
		columnwidth: 120,
	},
	{
		prop: "InvClassName",
		label: "产品线名称",
		columnwidth: 120,
	},
	{
		prop: "YearMonth",
		label: "出入库年月",
		columnwidth: 100,
	},
	{
		prop: "CompanyName",
		label: "上报方名称",
		columnwidth: 230,
	},
	{
		prop: "ValiDate",
		label: "有效期至",
		columnwidth: 150,
	},
	{
		prop: "MFName",
		label: "生产厂商",
		columnwidth: 230,
	},
	{
		prop: "CusType",
		label: "上报方类型",
		columnwidth: 120,
	}
];
export default headerData;